module.exports = __webpack_public_path__ + "static/media/supported_coins_page_arrow.06f8a86f.svg";